import { FormattedMessage } from 'react-intl';
import React from 'react';
import { IN_TRANSIT_VIEW_ID, SHIPPED_VIEW_ID } from './view-id-constants';

export const InTransit = {
  label: <FormattedMessage defaultMessage='In Transit' description='ordersPage.nav.inTransit' id='9CRRez' />,
  id: IN_TRANSIT_VIEW_ID,

  expandedDescription: (
    <FormattedMessage defaultMessage='Shipped / In Transit' description='ordersPage.nav.inTransitExpanded' id='eol61e' />
  ),

  parentId: SHIPPED_VIEW_ID,
};
